import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Switch } from "@/components/ui/switch";
import { api } from "@/lib/api";
import BackorderTable from "@/components/backorders/BackorderTable";

const STATUSES = [["", "Açık (tümü)"], ["stok_bekliyor", "Stok Bekliyor"], ["stok_geldi", "Stok Geldi"], ["kismen", "Kısmen Karşılandı"], ["tamamlandi", "Tamamlandı"], ["iptal", "İptal"]];

export default function CustomerBackordersTab({ customerId }) {
  const [sp] = useSearchParams();
  const [status, setStatus] = useState("");
  const [closed, setClosed] = useState(false);
  const [items, setItems] = useState(null);
  const load = () => api.get(`/customers/${customerId}/backorders`, { params: { status, include_closed: closed } }).then(({ data }) => setItems(data.items)).catch(() => setItems([]));
  useEffect(() => { load(); }, [customerId, status, closed]); // eslint-disable-line react-hooks/exhaustive-deps
  const hi = sp.get("backorder");
  const ord = sp.get("order");
  const shown = ord && items ? items.filter((b) => b.source_order_id === ord || b.source_order_no === ord) : items;
  useEffect(() => { if (hi && items) document.querySelector(`[data-testid="backorder-row-${hi}"]`)?.scrollIntoView({ block: "center" }); }, [hi, items]);
  return (
    <div className="panel overflow-hidden" data-testid="customer-backorders-tab">
      <div className="flex flex-wrap items-center gap-3 p-3 border-b">
        <select className="h-8 border rounded text-[13px] px-2" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="customer-backorders-status">{STATUSES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <label className="flex items-center gap-2 text-[12px] text-slate-600"><Switch checked={closed} onCheckedChange={setClosed} data-testid="customer-backorders-closed-toggle" />Kapananları da göster (Tamamlandı / İptal)</label>
      </div>
      {!items ? <div className="h-24 animate-pulse" /> : <>{ord && <div className="px-3 py-1.5 text-[12px] bg-amber-50 text-amber-800" data-testid="customer-backorders-order-filter">Yalnız {shown[0]?.source_order_no || "seçili sipariş"} bekleyenleri gösteriliyor</div>}<BackorderTable items={shown} onDone={load} highlight={hi} /></>}
    </div>
  );
}
